import { render, staticRenderFns } from "./ConfigScheduleAddNearMatchNotifications.vue?vue&type=template&id=06ffbd6c&scoped=true&"
import script from "./ConfigScheduleAddNearMatchNotifications.vue?vue&type=script&lang=js&"
export * from "./ConfigScheduleAddNearMatchNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ConfigScheduleAddNearMatchNotifications.vue?vue&type=style&index=0&id=06ffbd6c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ffbd6c",
  null
  
)

export default component.exports